import React from 'react';

const NoticeCardSkeleton = () => {
    return (
        <div className="notice-card-new skeleton-card">
            {/* Avatar Section */}
            <div className="notice-author-new">
                <div className="skeleton-avatar-large" />
            </div>

            {/* Content Section */}
            <div className="notice-content-new">
                <div className="skeleton-text skeleton-title-medium" style={{ marginBottom: '8px' }} />
                <div className="skeleton-text skeleton-line" style={{ width: '100%', marginBottom: '4px' }} />
                <div className="skeleton-text skeleton-line" style={{ width: '80%', marginBottom: '8px' }} />
                <div className="skeleton-text skeleton-date" />
            </div>
        </div>
    );
};

export default NoticeCardSkeleton;
